// oxlint-disable complexity
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, of, switchMap } from 'rxjs';
import { DealerApiService } from '../../api/dealer-api.service';
import { injectRequestContext } from '../../utilities/redirect';
import { actions } from './dealer.actions';
import { state } from './dealer.reducer';

@Injectable()
export class DealerEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);
    protected readonly platformId = inject(PLATFORM_ID);
    protected readonly reqContext = injectRequestContext();

    loadDealerBySlug$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadDealerBySlug),
            concatLatestFrom(() => this.store.select(state.selectDealer)),
            switchMap(([{ slug }, dealer]) => {
                if (dealer && slug === dealer.slug) {
                    return [];
                }

                return from(this.dealerApi.getDealerBySlug(slug)).pipe(
                    switchMap((dealer) => {
                        return [
                            actions.loadDealerBySlugSuccess({
                                dealer: {
                                    ...dealer,
                                    name: dealer.name || '',
                                    slug: dealer.slug || '',
                                },
                            }),
                        ];
                    }),
                    catchError((error) => of(actions.loadDealerBySlugFailure({ error }))),
                );
            }),
        );
    });

    loadVehicleMarketDealerBySlug$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadVehicleMarketDealerBySlug),
            concatLatestFrom(() => this.store.select(state.selectVehicleMarketDealer)),
            switchMap(([{ slug }, dealer]) => {
                if (dealer && slug === dealer.slug) {
                    return [];
                }

                return from(this.dealerApi.getVehicleMarketDealerBySlug(slug)).pipe(
                    switchMap((dealer) => {
                        return [
                            actions.loadVehicleMarketDealerBySlugSuccess({
                                dealer,
                            }),
                        ];
                    }),
                    catchError((error) => of(actions.loadVehicleMarketDealerBySlugFailure({ error }))),
                );
            }),
        );
    });
}
